/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

// Client-side pre-filter for the username-availability indicator so a reserved name shows as
// unavailable as the user types, instead of "available" then failing on submit. The SERVER
// (firebase/functions/usernameModeration.js `isUsernameReserved`) is authoritative and still rejects
// these at registration — KEEP THIS LIST IN SYNC with RESERVED_SUBSTRINGS there.
const RESERVED_SUBSTRINGS = [
  'greengod', 'greengodgames',
  'admin', 'administrator', 'moderator', 'official',
  'support', 'system', 'sysadmin', 'superuser', 'staff',
];

/** True if the name contains a reserved brand/authority term (matched on the separator-stripped form). */
export const isReservedUsername = (username: string): boolean => {
  const collapsed = (username || '').toLowerCase().replace(/[\s._-]+/g, '');
  return RESERVED_SUBSTRINGS.some((term) => collapsed.includes(term));
};
